import React from 'react';
import { useNotificacao } from '../../contexts/NotificacaoContext';
import { motion, AnimatePresence } from 'framer-motion';

const Notificacoes: React.FC = () => {
  const { notificacoes, removerNotificacao } = useNotificacao();

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2">
      <AnimatePresence>
        {notificacoes.map((notificacao) => {
          // Definir cores com base no tipo de notificação
          let bgColor = 'bg-blue-500';
          let iconPath = 'M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'; // ícone de info

          if (notificacao.tipo === 'sucesso') {
            bgColor = 'bg-green-500';
            iconPath = 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'; // ícone de check
          } else if (notificacao.tipo === 'aviso') {
            bgColor = 'bg-yellow-500';
            iconPath = 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z'; // ícone de aviso
          } else if (notificacao.tipo === 'erro') {
            bgColor = 'bg-red-500';
            iconPath = 'M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z'; // ícone de erro
          }

          return (
            <motion.div
              key={notificacao.id}
              initial={{ opacity: 0, y: 50, scale: 0.3 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, scale: 0.5, transition: { duration: 0.2 } }}
              className={`${bgColor} text-white p-4 rounded-lg shadow-lg w-80 flex items-start`}
            >
              <div className="flex-shrink-0 mr-3">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={iconPath} />
                </svg>
              </div>
              <div className="flex-1">
                <h4 className="font-medium">{notificacao.titulo}</h4>
                <p className="text-sm opacity-90">{notificacao.mensagem}</p>
              </div>
              <button
                onClick={() => removerNotificacao(notificacao.id)}
                className="ml-4 text-white opacity-70 hover:opacity-100 transition-opacity"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
};

export default Notificacoes;
